import { Alert, Button, Col, Row } from 'antd';
import React, { useState } from 'react';
import Date from '../../../components/Formatter/Date';
import InductionUpdate from './InductionUpdate';
import PeriodUpdate from './PeriodUpdate';
import RegistrationWhatsappNotification from './RegistrationWhatsappNotification';
import {useSelector} from 'react-redux';

const ProjectDescription = ({ item, passport }) => {
  const [detailed, setDetailed] = useState(false);
  const { authUser } = useSelector(({ auth }) => auth);
  
  return (
    <div className="gx-mt-2">
      <Row>
        <Col span={8}>
          <DetailItem label={`Divisi Operasi`} value={item.division.label}/>
        </Col>
        <Col span={10}>
          <DetailItem label={`Periode`} value={<><Date value={item.start_date}/> s/d <Date value={item.end_date}/></>}/>
          {authUser.vendor ? null : <PeriodUpdate item={item} passport={passport} />}
        </Col>
        <Col span={6}>
          <DetailItem label={`Status`} value={item.status.is_pending ? `Menunggu Verifikasi` : item.status.is_expired ? "Kedaluwarsa" :item.status.is_active ? `Aktif` : item.status.is_inactive ? `Tidak Aktif` : `Dihapus`}/>
        </Col>
        {item.status.is_scheduled ? (
          <>
            <Col span={8}>
              <DetailItem label={`HSE Level`} value={`${item.level.id}${item.quality}`}/>
            </Col>
            <Col span={10}>
              <DetailItem label={`Tanggal Induksi`} value={<Date value={item.induction_date} />} />
              {authUser.vendor ? null : <InductionUpdate item={item} passport={passport} />}
            </Col>
          </>
        ) : null}
        {detailed ? (
          <>
            <Col span={6}>
              <DetailItem label={`Hasil Induksi`} value={item.induction_status ? `Passed` : `Not Passed`}/>
            </Col>
            <Col span={8}>
              <DetailItem label={`Persetujuan PM`} value={item.approval ? `Setuju` : `Tidak`}/>
            </Col>
          </>
        ) : null}
      </Row>
      {item.status.is_active || item.status.is_inactive ? (
        <div className="gx-mt-2">
          <Button type="default" size="small" onClick={() => setDetailed(!detailed)}>{detailed ? `Sembunyikan` : `Lihat Detail`}</Button>
        </div>
      ) : null}
      {item.status.is_pending ? (
        <>
          <Alert message="Menunggu Verifikasi" type="warning" className="gx-mt-2" />
          {passport.actions.waiting_for_verification ? <RegistrationWhatsappNotification passport={passport} /> : null}
        </>
      ) : null}
    </div>
  );
}

export default ProjectDescription;

const DetailItem = (props) => {
  return (
    <div className="gx-mb-2">
      <div className="gx-text-sm gx-text-muted">{props.label}</div>
      <div>{props.value}</div>
    </div>
  );
}